<plugins-text-input
  [formControl]="control"
  [inputId]="inputId"
  [errorId]="errorId"
  [color]="baseColor"
  [class.with-select]="withSelect"
  role="combobox"
  ariaAutocomplete="list"
  [placeholder]="placeholder"
  [inputClass]="inputClass"
  [inputStyle]="inputStyle"
  [ariaLabel]="ariaLabel"
  [ariaLabelledBy]="ariaLabelledBy"
  [ariaControls]="autocompleteId"
  [ariaExpanded]="(optionsDisplayed$ | async) ?? false"
  [ariaActivedescendant]="(focusedOptionId$ | async) ?? undefined"
  (keyPressed)="onKeydown($event)"
  (click)="onClick()"
  cdkOverlayOrigin
  #originOverlay="cdkOverlayOrigin"
/>

@if (withSelect) {
  <icon-chevron class="select-icon" />
}

@if (cdk$ | async; as cdk) {
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="originOverlay"
    [cdkConnectedOverlayFlexibleDimensions]="cdk.flexibleDimensions"
    [cdkConnectedOverlayViewportMargin]="cdk.viewportMargin"
    [cdkConnectedOverlayWidth]="(autocompleteWidth$ | async) ?? 0"
    [cdkConnectedOverlayOpen]="(optionsDisplayed$ | async) ?? false"
  >
    @if (options?.length || noOptionsTemplateRef) {
      <ul
        [attr.id]="autocompleteId"
        role="listbox"
        [style]="{ '--max-height': OPTIONS_MAX_HEIGHT + 'px' }"
        #autocompleteRef
      >
        @if (options?.length) {
          @if (
            {
              focusedOptionIndex: focusedOptionIndex$ | async,
              optionStyles: optionStyles$ | async,
            };
            as data
          ) {
            @for (
              option of options;
              track trackByOption(index, option);
              let index = $index
            ) {
              <li
                role="option"
                tabindex="-1"
                [attr.id]="'opt-' + index"
                [ngStyle]="data.optionStyles?.[index]"
                [attr.aria-selected]="data.focusedOptionIndex === index"
                (mouseenter)="onOptionHoverChange(index)"
                (mouseleave)="onOptionHoverChange(null)"
                (click)="onSelectOption(option)"
                (keydown.enter)="onSelectOption(option)"
                #optionRef
              >
                <ng-container
                  [ngTemplateOutlet]="optionTemplateRef || defaultOption"
                  [ngTemplateOutletContext]="{ $implicit: option }"
                />
              </li>
            }
          }
        } @else {
          @if (noOptionsTemplateRef) {
            <ng-container [ngTemplateOutlet]="noOptionsTemplateRef" />
          }
        }
      </ul>
    }
  </ng-template>
}

<ng-template let-option #defaultOption>
  <span>{{ option }}</span>
</ng-template>
